import { Pipe, PipeTransform } from '@angular/core';
import { BancoDto } from '../models/banco-dto';

@Pipe({
  name: 'agenciasPipe'
})
export class AgenciasPipe implements PipeTransform {

  transform(bancos: BancoDto[]): string[] {
    return bancos.map(banco => {
      if (banco == null) {
        return "";
      }

      return formataCodigoBanco(banco.codigo) + " " + banco.nome;
    });
  }
}

function formataCodigoBanco(codigo: number): string{
  return codigo.toString().padStart(3, '0');
}
